import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import CustomsFormsColumn from '../../components/columns/customs-forms-column';
import * as PrintActions from '../../store/printing/print.actions';
import Global from '../../store/global-selectors';

export const ShippingCustomsFormColumnContainer = ({ fulfillmentId }) => {
  const dispatch = useDispatch();
  const { labelFulfillment, fulfillmentPlanId } =
    useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const onLinkClicked = useCallback(() => {
    dispatch(PrintActions.printCustomsForms([fulfillmentPlanId]));
  }, [fulfillmentPlanId, dispatch]);
  const { shouldHaveCustomsForm, hasCustomsFormFile } = labelFulfillment ?? {};

  return <CustomsFormsColumn hasCustomsForm={shouldHaveCustomsForm} hasFormFile={hasCustomsFormFile} onLinkClicked={onLinkClicked} />;
};

ShippingCustomsFormColumnContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};
